export const Types = {
    GET_MAINTENANCE_TYPE: "GET_MAINTENANCE_TYPE",
    SET_MAINTENANCE_TYPE: "SET_MAINTENANCE_TYPE",
    ADD_MAINTENANCE_TYPE: "ADD_MAINTENANCE_TYPE",
    UPDATE_MAINTENANCE_TYPE: "UPDATE_MAINTENANCE_TYPE",
    DELETE_MAINTENANCE_TYPE: "DELETE_MAINTENANCE_TYPE",
    GET_MAIL_GROUP: "GET_MAIL_GROUP",
    SET_MAIL_GROUP: "SET_MAIL_GROUP",
    GET_MAIL_GROUP_PERIOD: "GET_MAIL_GROUP_PERIOD",
    SET_MAIL_GROUP_PERIOD: "SET_MAIL_GROUP_PERIOD",
    GET_PLANTS: "GET_PLANTS",
    SET_PLANTS: "SET_PLANTS",
    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getMaintenanceType = (payload) => {
    return {
        type: Types.GET_MAINTENANCE_TYPE,
        payload: payload,
    };
};

export const setMaintenanceType = (payload) => {
    return {
        type: Types.SET_MAINTENANCE_TYPE,
        payload: payload,
    };
};

export const getMailGroup = (payload) => {
    return {
        type: Types.GET_MAIL_GROUP,
        payload: payload,
    };
};

export const setMailGroup = (payload) => {
    return {
        type: Types.SET_MAIL_GROUP,
        payload: payload,
    };
};


export const getMailGroupPeriod = (payload) => {
    return {
        type: Types.GET_MAIL_GROUP_PERIOD,
        payload: payload,
    };
};

export const setMailGroupPeriod = (payload) => {
    return {
        type: Types.SET_MAIL_GROUP_PERIOD,
        payload: payload,
    };
};

export const getPlants = () => ({
    type: Types.GET_PLANTS,
});

export const setPlants = (payload) => ({
    type: Types.SET_PLANTS,
    payload: payload,
});


export const addMaintenanceType = (payload) => {
    return {
        type: Types.ADD_MAINTENANCE_TYPE,
        payload: payload,
    };
};

export const updateMaintenanceType = (payload) => {
    return {
        type: Types.UPDATE_MAINTENANCE_TYPE,
        payload: payload,
    };
};

export const deleteMaintenanceType = (payload) => {
    return {
        type: Types.DELETE_MAINTENANCE_TYPE,
        payload: payload,
    };
};

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});

